import React from "react"
import Grid from '@mui/material/Grid'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import SimpleTextField from '../../../../../components/Forms/SimpleTextField'
import { RESP_SUPPORT_OPTIONS } from '../../../_pewsCalc'

// Paediatric (PEWS) extras — the oxygen delivery score needs the delivered
// concentration and whether the patient is on High Flow/CPAP/BiPAP, not just
// Yes/No
export const SuppO2Fio2 = ({ value, onChange }) => (
  <Grid item xs={12} md={6} lg={4} xl={3}>
    <SimpleTextField
      type="number"
      value={value}
      onChange={onChange}
      label="O2 Concentration (%)"
      InputProps={{
        inputProps: { min: 21, max: 100, step: 'any' },
      }}
    />
  </Grid>
)

export const RespSupport = ({ value, onChange }) => (
  <Grid item xs={12} md={6} lg={4} xl={3}>
    <FormControl fullWidth>
      <InputLabel>High Flow/CPAP/BiPAP</InputLabel>
      <Select
        value={value}
        onChange={onChange}
        label="High Flow/CPAP/BiPAP"
      >
        {RESP_SUPPORT_OPTIONS.map((option) => (
          <MenuItem key={option} value={option}>
            {option}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  </Grid>
)

const SuppO2 = ({value, onChange}) => (
    <Grid item xs={12} md={6} lg={4} xl={3}>
          <FormControl fullWidth>
            <InputLabel>Supplemental Oxygen</InputLabel>
            <Select
              value={value}
              onChange={onChange}
              label="Supplemental Oxygen"
            >
              <MenuItem value="Yes">Yes</MenuItem>
              <MenuItem value="No">No</MenuItem>
            </Select>
          </FormControl>
        </Grid>
)

export default SuppO2